import { ResponsiveContainer, AreaChart, Area } from "recharts";

/** Tiny sparkline for KPI cards. data: [{value: number}] */
export default function Sparkline({ data, color = "#C5A059", height = 36, testId }) {
  if (!data || data.length === 0) return null;
  return (
    <div style={{ height, minHeight: height }} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={`spark-${color}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.45} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.6}
            fill={`url(#spark-${color})`}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
